import intl from '../../services/intl-service';
import Joi from 'joi-browser';

export const dodavanjeZastupnikaSchema = {
   prezimeIme: Joi.string()
      .required()
      .max(21)
      .label(intl.getTranslate('zastupnici.prezimeIme'))
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'zastupnici.prezimeImeValidator'
            )}`
         };
      }),
   operativniBrojZastupnika: Joi.number()
      .integer()
      .min(0)
      .max(9999)
      .label(intl.getTranslate('zastupnici.operativniBrojZastupnika'))
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'zastupnici.operativniBrojZastupnikaValidator'
            )}`
         };
      }),
   kategorija: Joi.number()
      .integer()
      .min(0)
      .max(9999)
      .label(intl.getTranslate('zastupnici.kategorija'))
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'zastupnici.kategorijaValidator'
            )}`
         };
      }),
   operativniBrojNadredjenogZastupnika: Joi.number()
      .integer()
      .min(0)
      .max(99999)
      .label(
         intl.getTranslate('zastupnici.operativniBrojNadredjenogZastupnika')
      )
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'zastupnici.operativniBrojNadredjenogZastupnikaValidator'
            )}`
         };
      }),
   telefon: Joi.any().optional(),
   sifraProdajnogMjesta: Joi.number()
      .integer()
      .min(1)
      .max(9999)
      .required()
      .label(intl.getTranslate('zastupnici.sifraProdajnogMjesta'))
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'zastupnici.sifraProdajnogMjestaValidator'
            )}`
         };
      }),
   password: Joi.number()
      .integer()
      .min(1)
      .max(999999)
      .required()
      .label(intl.getTranslate('zastupnici.password'))
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'zastupnici.passwordValidator'
            )}`
         };
      }),
   prezimeImeNadredjenogZastupnika: Joi.any().optional(),
   gradAdresaProdajnogMjesta: Joi.any().optional(),
   grupaKorisnika: Joi.number()
      .integer()
      .min(0)
      .max(50)
      .required()
      .label(intl.getTranslate('zastupnici.grupaKorisnika'))
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'zastupnici.grupaKorisnikaValidator'
            )}`
         };
      }),
   postotakProvizije: Joi.number()
      .integer()
      .min(0)
      .max(9999)
      .required()
      .label(intl.getTranslate('zastupnici.postotakProvizije'))
      .error((errors) => {
         return {
            message: `${errors[0].flags.label} ${intl.getTranslate(
               'zastupnici.postotakProvizijeValidator'
            )}`
         };
      }),
   depozit: Joi.any().optional(),
   napomena: Joi.any().optional()
};
